'use client';

import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
interface ReactionButtonProps {
  reactionType: string;
  count: number;
  isActive: boolean;
  onClick: () => void;
  emoji: string;
  disabled?: boolean;
}
export function ReactionButton(t0) {
  const $ = _c(14);
  const {
    reactionType,
    count,
    isActive,
    onClick,
    emoji,
    disabled: t1
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const t2 = isActive ? "bg-primary-50 border-primary-300 text-primary-700" : "bg-white border-gray-200 text-gray-600 hover:border-gray-300";
  const t3 = disabled ? "cursor-not-allowed" : "cursor-pointer";
  let t4;
  if ($[0] !== t2 || $[1] !== t3) {
    t4 = clsx("flex items-center gap-1 px-3 py-1.5 rounded-full border transition-all", "hover:scale-105 active:scale-95", t2, t3);
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const t5 = `${reactionType} (${count})`;
  let t6;
  if ($[3] !== emoji) {
    t6 = <span className="text-lg leading-none">{emoji}</span>;
    $[3] = emoji;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== count) {
    t7 = count > 0 && <span className="text-sm font-medium">{count}</span>;
    $[5] = count;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== disabled || $[8] !== onClick || $[9] !== t4 || $[10] !== t5 || $[11] !== t6 || $[12] !== t7) {
    t8 = <button onClick={onClick} disabled={disabled} className={t4} title={t5}>{t6}{t7}</button>;
    $[7] = disabled;
    $[8] = onClick;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
}